import {Dispatch, SetStateAction} from "react";
import {useModal} from "../../../../../hooks";

interface PropsType {
    tab: number
    setTab: Dispatch<SetStateAction<number>>
    isModify: boolean
}

export default function TabNav({tab, setTab, isModify}: PropsType) {
    const {handleModal} = useModal();

    const clickTab = (n: number) => {
        if (isModify) {
            handleModal({
                isOpen: true,
                contents: "편집 중에는 탭을 변경할 수 없습니다.",
                type: "alert",
            });
        } else {
            setTab(n)
        }
    }

    return <div className="mybtns_group">
        <div className="btn-group" role="group" aria-label="">
            <button type="button"
                    className={tab == 1 ? "btn btn-light active" : "btn btn-light"}
                    onClick={() => clickTab(1)}>연간매출
            </button>
            <button type="button" className={tab == 2 ? "btn btn-light active" : "btn btn-light"}
                    onClick={() => clickTab(2)}>고객사 별 매출
            </button>
        </div>
        <div className="mybtns_group_toolbar"></div>
    </div>
}